/**
 * Fleet Maintenance shared enums
 *
 * Single source of truth for maintenance type and status values.
 * Used by both backend entity and frontend API client.
 */

export enum MaintenanceType {
  SCHEDULED = 'scheduled',
  UNSCHEDULED = 'unscheduled',
  BREAKDOWN = 'breakdown',
  INSPECTION = 'inspection',
  REPAIR = 'repair',
  TIRE_CHANGE = 'tire_change',
  OIL_CHANGE = 'oil_change',
  BRAKE_SERVICE = 'brake_service',
  OTHER = 'other',
}

export enum MaintenanceStatus {
  SCHEDULED = 'scheduled',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  OVERDUE = 'overdue',
}
